import { every } from "lodash";

export function defaultFilter(): boolean {
  return true;
}

export function combineFilters<Input>(...filters: Array<(input: Input) => boolean>): (input: Input) => boolean {
  return (input) => every(filters, (v) => v(input));
}

export function checkInArray<Value>(input: unknown, array: Array<Value>): input is Value {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return array.includes(input);
}
